import { EVENT5K } from "@/constants/testIds";
import { Clock, MapPin, Car, Package, Flag, CloudRain, Users, Timer } from "lucide-react";

export default function EventDetails() {
  const items = [
    { icon: Clock, title: "Check-In", value: "7:30 – 8:45 AM", note: "Grab your bib + shirt", accent: "#00A651" },
    { icon: Flag, title: "Race Start", value: "9:00 AM", note: "5K + 1-Mile at Hartsell Shelter", accent: "#EC008C" },
    { icon: MapPin, title: "Where to Meet", value: "Hartsell Shelter", note: "Frank Liske Park · Concord, NC", accent: "#00A651" },
    { icon: Car, title: "Parking", value: "On-site parking", note: "Details will be shared closer to event day", accent: "#EC008C" },
    { icon: Package, title: "What to Bring", value: "Water · Sneakers · Vibes", note: "Family, friends, and your business swag", accent: "#00A651" },
    { icon: Timer, title: "Course", value: "5K + 1-Mile loop", note: "Route map to be released — family-friendly, all-pace-welcome course", accent: "#EC008C" },
    { icon: CloudRain, title: "Weather Policy", value: "Rain or shine", note: "Severe weather updates via email + social", accent: "#00A651" },
    { icon: Users, title: "After Party", value: "Community hangs", note: "Vendors, music, awards & photos", accent: "#EC008C" },
  ];

  return (
    <section id="details" data-testid={EVENT5K.sectionDetails} className="relative bg-[#0A0A0A] py-24 md:py-32 border-t border-[#27272A]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <div className="text-[11px] uppercase tracking-[0.3em] text-[#EC008C] font-bold mb-4">Event Day</div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-black uppercase tracking-tight text-white">
            Everything you need to <span className="text-[#00A651]">show up ready</span>.
          </h2>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {items.map(({ icon: Icon, title, value, note, accent }) => (
            <div key={title} className="bg-[#141414] border border-[#27272A] p-6 hover:border-white/40 transition-colors">
              <Icon className="w-6 h-6 mb-4" style={{ color: accent }} />
              <div className="text-[10px] uppercase tracking-[0.28em]" style={{ color: accent }}>{title}</div>
              <div className="mt-1 font-display text-xl font-bold uppercase text-white">{value}</div>
              <div className="text-sm text-[#A3A3A3] mt-1">{note}</div>
            </div>
          ))}
        </div>

        <div className="mt-8 bg-[#141414] border border-[#27272A] p-6 md:p-8 grid md:grid-cols-3 gap-6">
          <div className="md:col-span-2">
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#EC008C] font-bold">Route Map</div>
            <div className="mt-4 aspect-video bg-black border border-dashed border-[#27272A] flex items-center justify-center text-[#71717A] uppercase tracking-widest text-xs">
              Course map will be published here
            </div>
          </div>
          <div className="space-y-3">
            <div>
              <div className="text-[10px] uppercase tracking-[0.24em] text-[#A3A3A3]">Address</div>
              <div className="mt-1 text-white font-semibold">4001 Stough Rd<br/>Concord, NC 28027</div>
            </div>
            <div>
              <div className="text-[10px] uppercase tracking-[0.24em] text-[#A3A3A3]">Getting There</div>
              <a
                href="https://maps.google.com/?q=Hartsell+Shelter+Frank+Liske+Park+Concord+NC"
                target="_blank"
                rel="noreferrer"
                className="text-[#00A651] hover:text-[#1FBF3E] font-bold uppercase text-sm tracking-wider inline-flex items-center gap-2"
              >
                Open in Google Maps →
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
